import API from "../configs/axiosInstance";

const getAllEmailLeakages = (domainName, createdDate) => {
  return API({
    url: `account-service/v1/domain-mail-leakages/pageable`,
    method: "POST",
    data: {
      domainName,
      createdDate,
    },
  });
};

const getScanStatus = (scanId) => {
  return API({
    url: `osint-service/scanStatus`,
    method: "POST",
    data: {
      id: scanId,
    },
  });
};

const getScanSummary = (scanId, by) => {
  return API({
    url: `osint-service/scanSummary`,
    method: "POST",
    data: {
      id: scanId,
      by,
    },
  });
};

const getScanEventResults = (scanId, eventType) => {
  return API({
    url: `osint-service/scanEventResults`,
    method: "POST",
    data: {
      id: scanId,
      eventType,
    },
  });
};


const startEmailLeakageScan = (domainId) => {
  return API({
    url: `account-service/v1/domain-mail-leakages/scan?domainId=${domainId}`,
    method: "POST",
  });
};

const getMailSearchByDomain = (domainId) => {
  return API({
    url: `account-service/v2/domain-mail-leakages/${domainId}`,
    method: "POST",
  });
};

const searchLeakageByEmail = (leakageMailId, email) => {
  return API({
    url: `account-service/v2/domain-mail-leakages/${leakageMailId}/search-leakage`,
    method: "POST",
    params: {
      email,
    },
  });
};

const searchLeakageByCustomEmail = (email) => {
  return API({
    url: `account-service/v2/domain-mail-leakages/${email}/search-leakage`,
    method: "GET",
  });
}

const getEmailLeakagesPageable = (params = {}, data = {}) => {
  return API({
    url: `account-service/v2/domain-mail-leakages/pageable`,
    method: "POST",
    data,
    params
  });
};

const postMailLeakagesVip = (formattedData) => {
  return API({
    url: `account-service/v1/mail-leakages-vip`,
    method: "POST",
    data: formattedData
  });
}

const getVipEmailLeakagesPageable = (params = {}, data = {}) => {
  return API({
    url: `account-service/v1/mail-leakages-vip/pageable`,
    method: "POST",
    data: data,
    params: params
  });
}

const getVipEmailLeakagesDetails = (id) => {
  return API({
    url: `account-service/v1/mail-leakages-vip/data/${id}`,
    method: "GET",
  });
}

const postUsernameLeakagesVip = (formattedData) => {
  return API({
    url: `account-service/v1/username-leakage-vip-data`,
    method: "POST",
    data: formattedData,
  });
};

const getVipUsernameLeakagesPageable = (params = {}, data = {}) => {
  return API({
    url: `account-service/v1/username-leakage-vip-data/pageable`,
    method: "POST",
    data,
    params,
  });
};

const getVipUsernameLeakagesDetails = (id) => {
  return API({
    url: `account-service/v1/username-leakage-vip-data/${id}/leakage`,
    method: "GET",
  });
};

const getNewMailLeakagesPageable = (data) => {
  return API({
    url: `account-service/v2/new-domain-mail-leakages/pageable`,
    method: "POST",
    ...data
  })
}

const getNewMailLeakage = (data) => {
  return API({
    url: `account-service/v2/new-domain-mail-leakages/${data?.id}/pageable-data`,
    method: "POST",
    params: data?.params,
    data: data?.body
  });
}

const startNewMailLeakage = (data) => {
  return API({
    url: `account-service/v2/new-domain-mail-leakages`,
    method: "POST",
    data: data
  });
}

const exportNewMailLeakagesExcel = (id, filters = {}) => {
  return API({
    url: `account-service/v2/new-domain-mail-leakages/${id}/export-excel`,
    method: "POST",
    responseType: "blob",
    data: filters
  });
};

const getEmailLeakageService = {
  getAllEmailLeakages,
  getScanStatus,
  getScanSummary,
  getScanEventResults,
  startEmailLeakageScan,
  getMailSearchByDomain,
  searchLeakageByEmail,
  getEmailLeakagesPageable,
  searchLeakageByCustomEmail,
  postMailLeakagesVip,
  getVipEmailLeakagesPageable,
  getNewMailLeakagesPageable,
  getNewMailLeakage,
  startNewMailLeakage,
  getVipEmailLeakagesDetails,
  postUsernameLeakagesVip,
  getVipUsernameLeakagesPageable,
  getVipUsernameLeakagesDetails,
  exportNewMailLeakagesExcel
};

export default getEmailLeakageService;